import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CookieNotice from "../CookieNotice";
import { Toaster } from "sonner";

export const Layout = () => {
  const { pathname } = useLocation();

  // Smooth momentum scrolling, disabled when the user prefers reduced motion.
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  // Reset scroll on navigation + record a cookieless, aggregate page view.
  useEffect(() => {
    window.scrollTo(0, 0);
    if (pathname.startsWith("/admin") || pathname.startsWith("/login")) return;
    try {
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/stats/pageview`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ path: pathname }),
        keepalive: true,
      });
    } catch {
      /* non-blocking */
    }
  }, [pathname]);

  return (
    <div className="App">
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <Navbar />
      <main id="main-content" className="flex-1" tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
      <CookieNotice />
      <Toaster position="bottom-center" richColors closeButton />
    </div>
  );
};

export default Layout;
